import script from "./HealthStore.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthStore.vue?vue&type=script&setup=true&lang=js"

import "./HealthStore.vue?vue&type=style&index=0&id=81a42f34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81a42f34"]])

export default __exports__